export default __webpack_public_path__ + "static/media/linkedin.bd1e0093.svg";